// extracted by mini-css-extract-plugin
export default {"card":"card1_card__wDKG0","box":"card1_box__g9Ly4","boxLeft":"card1_boxLeft__AhyUH","boxRight":"card1_boxRight__eW73n","line":"card1_line__4fAdT"};